import {adminSearchConstants} from '_constants';

const INITIAL_STATE = {
    loading: false,
    searchData: [],
    exporting: false,
    visitedPages: {},
    queryParams: {},

    searchSummary: {},
    loadingSummary: false,
    searchSummaryError: '',
};

export function searchReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case adminSearchConstants.ADMIN_SEARCH_REQUEST:
            return {...state, loading: true, error: ''};
        case adminSearchConstants.DELETE_VISITED_PAGES:
            return { ...state, visitedPages: {} };
        case adminSearchConstants.ADMIN_SEARCH_SUCCESS:
            return { ...state,
                searchData: action.payload.searchParams,
                visitedPages: {...state.visitedPages, [`page${action.payload.page}`]:action.payload.searchParams},
                queryParams: action.payload.queryParams,
                loading: false };
        case adminSearchConstants.ADMIN_SEARCH_FAILURE:
            return {...state, error: action.error, loading: false};

        case adminSearchConstants.EXPORT_ADMIN_SEARCH_REQUEST:
            return {...state, exporting: true, error: ''};
        case adminSearchConstants.EXPORT_ADMIN_SEARCH_SUCCESS:
            return { ...state, exporting: false };
        case adminSearchConstants.EXPORT_ADMIN_SEARCH_FAILURE:
            return {...state, error: action.error, exporting: false};

        case adminSearchConstants.ADMIN_SEARCH_SUMMARY_REQUEST:
            return {...state, loadingSummary: true, searchSummaryError: ''};
        case adminSearchConstants.ADMIN_SEARCH_SUMMARY_SUCCESS:
            return { ...state, loadingSummary: false, searchSummary: action.payload };
        case adminSearchConstants.ADMIN_SEARCH_SUMMARY_FAILURE:
            return {...state, searchSummaryError: action.error, loadingSummary: false};

        default:
            return state
    }
}